export default function nav() {

  $('.hamburger').click(function(e){
    e.preventDefault();

    $('html').toggleClass('menu-opened');
  });

  $('.mobile-navs').css('padding-top', $('#header').outerHeight() + 45);
  $('.mobile-navs').css('padding-bottom', $('.mobile-link-tickets').outerHeight());
  $('.mobile-navs .menu-item-has-children > a').append('<i class="fas fa-plus"></i>');

  $('.menu-item-has-children > a i').click(function(e){
    e.preventDefault();

    $(this).closest('li').toggleClass('open');
    $(this).toggleClass('fa-plus fa-minus');
  });

}
